import { defineStore } from 'pinia';

export const useAdDisplayStore = defineStore('adDisplay', {
    state: () => ({
        videoPlayCount: 0,
    }),
    actions: {
        incrementVideoPlayCount() {
            this.videoPlayCount++;
        },
        resetVideoPlayCount() {
            this.videoPlayCount = 0;
        },
        shouldShowVastAd(frequency) {
            if (frequency === 0) {
                return true;
            }
            if (frequency < 0) {
                return false;
            }

            this.videoPlayCount++;
            const shouldShow = this.videoPlayCount >= frequency;

            if (shouldShow) {
                this.videoPlayCount = 0;
            }

            return shouldShow;
        },
    },
}); 